const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
        case "in progress":
            return { label: "In Progress", bg: "#007BFF", hover: "#0056b3" };
        case "completed":
            return { label: "Completed", bg: "#28A745", hover: "#218838" };
        case "pending":
            return { label: "Pending", bg: "#FFC107", hover: "#e0a800" };
        case "cancelled":
            return { label: "Cancelled", bg: "#DC3545", hover: "#a71d2a" };
        case "rejected":
            return { label: "Rejected", bg: "#DC3545", hover: "#a71d2a" };
        case "approved":
            return { label: "Approved", bg: "#28A745", hover: "#218838" };
        case "scheduled":
            return { label: "Scheduled", bg: "#6C757D", hover: "#5a6268" };
        default:
            return { label: status || "Unknown", bg: "#6C757D", hover: "#5a6268" };
    }
};

export default getStatusStyle;